import {ID, Resource} from 'simpli-web-sdk'
import DeliveryTrackingResponseSchema from '@/schema/DeliveryTrackingResponse.schema'

export default class DeliveryTrackingResponse extends Resource {
  readonly $name: string = 'DeliveryTrackingResponse'
  readonly $endpoint: string = '/user/indicador/jornada-motorista'

  get $schema() {
    return DeliveryTrackingResponseSchema(this)
  }

  $id = 0
  nome: string | null = null
  primeiraData: string | null = null
  ultimaData: string | null = null

}
